<template>
    <v-container>
        <app-alert :text="error" v-if="error !== ''"></app-alert>
        <v-row  >
            <v-col class="text-center" >
                <h2 :style="`color:${mainColor}`">{{!collabId ? 'Agregar Nuevo Colaborador' : 'Editar Colaborador'}}</h2>
            </v-col>
        </v-row>
        <v-row  >
            <v-col cols="5">
                <v-row justify="end">
                    <v-col cols="11">
                        <v-text-field
                           :disabled="!collabId ? false : true"
                            label="Email"
                            v-model="email"
                            :rules="[rules.required]"
                        ></v-text-field>
                        <v-text-field
                           :disabled="!collabId ? false : true"
                            label="Contraseña"
                            v-model="password"
                            :rules="[rules.required]"
                        ></v-text-field>
                        <v-text-field
                            label="Foto URL"
                            v-model="photoUrl"
                            :rules="[rules.required]"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="5">
                <v-row>
                    <v-col cols="11">
                         <v-text-field
                            label="Nombres"
                            v-model="firstName"
                            :rules="[rules.required]"
                        ></v-text-field>
                        <v-text-field
                            label="Apellidos"
                            v-model="lastName"
                            :rules="[rules.required]"
                        ></v-text-field>
                        <v-text-field
                            label="Teléfono"
                            v-model="phone"
                            type="number"
                            :rules="[rules.required]"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row  style="position:relative">
            <v-col cols="12">
                <v-card-actions>
                    <v-col class="text-center" >
                        <v-btn
                        :color="mainColor"
                        text
                        @click="closeUserDialog"
                        >Cerrar</v-btn>
                        <v-btn
                        :loading="onLoading"
                        :disabled="onLoading"
                        :color="mainColor"
                        :dark="!onLoading"
                        @click="onSaveUser"
                        >Guardar</v-btn>
                    </v-col>
                </v-card-actions>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
/* eslint-disable no-console */
import { mdiDeleteOutline } from '@mdi/js'
import * as error from '../../../../errorscode.json'
import * as constants from '../../../../constants.json'

export default {
  props: ['user', 'dialog'],
  data () {
    return {
      companyId: '',
      companyName: '',
      email: '',
      firstName: '',
      lastName: '',
      password: '',
      phone: 0,
      photoUrl: '',
      role: '',
      userId: '',
      creationDate: '',
      deleteIcon: mdiDeleteOutline,
      mainColor: constants.MAINCOLOR,
      colorTitle: '#525252',
      rules: {
        required: value => !!value || 'Campo requerido'
      },
      error: ''
    }
  },

  created () {
    console.log('user:', this.user)
    this.companyId = localStorage.companyId
    this.companyName = localStorage.companyName
    this.email = this.user.email
    this.firstName = this.user.firstName
    this.lastName = this.user.lastName
    this.password = this.user.password
    this.phone = this.user.phone
    this.photoUrl = this.user.photoUrl
    this.role = 'editor'
    this.collabId = this.user.collabId
    this.creationDate = !this.collabId ? new Date() : this.user.creationDate
  },

  computed: {
    onLoading () {
      return this.$store.getters.getLoading
    }
  },

  methods: {
    async onSaveUser () {
      try {
        if (this.$store.getters.getCompanyStatus === 'inactive') {
          alert(error.ERROR100)
        } else {
          if (this.firstName.trim() === '' ||
              this.lastName.trim() === '' ||
              this.email.trim() === '' ||
              this.phone.trim() === '' ||
              this.role === '' ||
              this.password === '') {
            this.error = 'Todos los campos son obligatorios'
            return
          }
          // this.editDialog = false
          console.log('this.collabId: ', this.collabId)
          if (!this.collabId) {
            await this.$store.dispatch('actionCreateNewCollab', {
              companyId: this.companyId,
              companyName: this.companyName,
              email: this.email,
              firstName: this.firstName,
              lastName: this.lastName,
              password: this.password,
              phone: this.phone,
              photoUrl: this.photoUrl,
              role: this.role,
              userId: this.userId,
              creationDate: this.creationDate
            })
            this.$router.push('/')
          } else {
            await this.$store.dispatch('actionUpdateCollab', {
              companyId: this.companyId,
              companyName: this.companyName,
              email: this.email,
              firstName: this.firstName,
              lastName: this.lastName,
              password: this.password,
              phone: this.phone,
              photoUrl: this.photoUrl,
              role: this.role,
              userId: this.userId,
              creationDate: this.creationDate,
              collabId: this.collabId
            })
            this.dialog.flag = false
          }
        }
      } catch (error) {
        console.log(error)
        switch (error.code) {
          case 'auth/weak-password':
            this.error = 'La contraseña debe tener al menos 6 caracteres'
            break
          case 'auth/email-already-in-use':
            this.error = 'La dirección de email ya está siendo usada por otra cuenta'
        }
      }
    },

    closeUserDialog () {
      this.dialog.flag = false
    }
  }
}
</script>
